import React, { memo, useMemo } from "react";
import { Source, Layer, Marker } from "@vis.gl/react-maplibre";

const CLUSTER_SOURCE_ID = "h3-clusters-source";
const CLUSTER_CIRCLE_LAYER_ID = "h3-clusters-circle";

const getClusterCenter = (cluster) => cluster.objectsCentroid ?? cluster;

const getClusterTextSize = (count) => {
  if (count >= 1000) return 18;
  if (count >= 100) return 15;
  if (count >= 20) return 13;

  return 11;
};

const ClusterLayers = ({ clusters = [] }) => {
  const clusterFeatures = useMemo(
    () =>
      clusters
        .map((cluster) => {
          const center = getClusterCenter(cluster);

          return {
            ...cluster,
            center,
            count: cluster.count ?? 0,
          };
        })
        .filter(({ center, h3Index }) => {
          return (
            typeof center.lat === "number" &&
            typeof center.lon === "number" &&
            h3Index
          );
        }),
    [clusters],
  );

  const data = useMemo(
    () => ({
      type: "FeatureCollection",
      features: clusterFeatures.map((cluster) => {
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [cluster.center.lon, cluster.center.lat],
          },
          properties: {
            h3Index: cluster.h3Index,
            count: cluster.count,
          },
        };
      }),
    }),
    [clusterFeatures],
  );

  return (
    <>
      <Source id={CLUSTER_SOURCE_ID} type="geojson" data={data}>
        <Layer
          id={CLUSTER_CIRCLE_LAYER_ID}
          type="circle"
          paint={{
            "circle-radius": [
              "interpolate",
              ["linear"],
              ["get", "count"],
              1,
              12,
              5,
              16,
              20,
              20,
              100,
              26,
              500,
              42,
              1000,
              54,
            ],
            "circle-color": "#0066A6",
            "circle-opacity": 0.85,
            "circle-stroke-color": "#ffffff",
            "circle-stroke-width": 2,
          }}
        />
      </Source>

      {clusterFeatures.map((cluster) => (
        <Marker
          key={cluster.h3Index}
          longitude={cluster.center.lon}
          latitude={cluster.center.lat}
          anchor="center"
          style={{ pointerEvents: "none" }}
        >
          <div
            style={{
              color: "#ffffff",
              fontSize: getClusterTextSize(cluster.count),
              // fontWeight: 600,
              lineHeight: 1,
              pointerEvents: "none",
              textAlign: "center",
              textShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
              userSelect: "none",
            }}
          >
            {cluster.count}
          </div>
        </Marker>
      ))}
    </>
  );
};

export default memo(ClusterLayers);
